import { Component, Injector } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import {
  AccountServiceProxy,
  AuthenticateModel,
  CheckResetCodeExpireDateInput,
  ResetPasswordInput,
} from "@shared/service-proxies/service-proxies";
import { AbpValidationError } from "@shared/components/validation/abp-validation.api";
import { AppAuthService } from "@shared/auth/app-auth.service";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  templateUrl: "./reset-password-sms-code.component.html",
  animations: [appModuleAnimation()],
})
export class ResetPasswordSmsCodeComponent extends AppComponentBase {
  model = new ResetPasswordInput();
  cpf: string;
  resetCode: string;
  dataHora:moment.Moment;

  cpfCnpjExibicao:string;

  saving = false;
  newPassword = true;
  showPassword = true;

  newPasswordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey:
        "PasswordsMustBeAtLeast8CharactersContainLowercaseUppercaseNumber",
    },
  ];
  confirmNewPasswordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "validateEqual",
      localizationKey: "PasswordsDoNotMatch",
    },
  ];

  constructor(
    injector: Injector,
    private router: Router,
    private _route: ActivatedRoute,
    private _appAuthService: AppAuthService,
    private _accountService: AccountServiceProxy,
    public bsModalRef: BsModalRef,
  ) {
    super(injector);
  }

  ngOnInit() {

    abp.ui.setBusy();
    this.cpfCnpjEmailMask();
    this.model.cpf = this.cpf.replace(/\D/g, '');
    this.model.resetCode = this.resetCode;
    this.model.dataHora = this.dataHora;
    this.model.userId = 0;
    if (!this.model.cpf || !this.model.resetCode) {
      abp.ui.clearBusy();
      this.goToLoginPage();
      return;
    }

    setTimeout(() => {
      this.checkResetCodeExpireDate();
    }, 100);
  }

  checkResetCodeExpireDate() {
    const dto = new CheckResetCodeExpireDateInput(this.model);
    this._accountService.checkResetCodeExpireDate(dto).subscribe(
      (r) => {
        if (!r.isExpired) {
          abp.ui.clearBusy();
          this.cpf = r.cpf;
        } else {
          abp.message.error(
            this.l("RecoverPasswordExpiredTime"),
            this.l("ExpiredTime")
          );
          this.goToLoginPage();
        }
        abp.ui.clearBusy();
      },
      () => {
        abp.ui.clearBusy();
        this.goToLoginPage();
      }
    );
  }

  changePassword() {
    abp.ui.setBusy();
    this.saving = true;
    this._accountService
      .resetPassword(this.model)
      .pipe(
        finalize(() => {
          this.saving = false;
          abp.ui.clearBusy();
        })
      )
      .subscribe((success) => {
        if (success) {
          // Logar após alterar senha
          const authenticateModel = new AuthenticateModel();
          authenticateModel.userNameOrEmailAddress = this.cpf;
          authenticateModel.password = this.model.newPassword;

          this._appAuthService.authenticateModel = authenticateModel;
          this._appAuthService.authenticate(() => {
            window.location.href = window.location.origin;
          });

        }
      });
  }

  private goToLoginPage() {
    this.router.navigate(["../login"], { relativeTo: this._route });
  }

  visualizarSenha(pass) {
    if(pass == "showPassword") this.showPassword = !this.showPassword;
    else if(pass == "newPassword") this.newPassword = !this.newPassword;
  }

  cpfCnpjEmailMask() {
    let valor = this.cpf
    const cpfOrCnpj = valor.replace(/\D/g, '');
    if (cpfOrCnpj.length == valor.length) {
      if (cpfOrCnpj.length <= 11) {
        this.aplicarMascaraCpf(valor);
      } else if (cpfOrCnpj.length <= 14) {
        this.aplicarMascaraCnpj(valor);
      }
    }
  }

  private aplicarMascaraCpf(valor) {
    this.cpfCnpjExibicao = valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }
  private aplicarMascaraCnpj(valor) {
    this.cpfCnpjExibicao = valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
  }
}
